// Add-to-cart without leaving the page, for any <form data-ng-add> posting to /cart/add.
// Shows a toast with the cart total and the gap to free shipping, and updates the header count.
// Without JS the form still posts normally and Shopify redirects to /cart.
(() => {
  const cfg = window.ngCart || {};
  const money = (cents) => `${(cents / 100).toLocaleString('he-IL', { maximumFractionDigits: 2 })} ₪`;

  let toast;
  function showToast(html, isError) {
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ng ng-toast';
      document.body.appendChild(toast);
    }
    toast.setAttribute('role', isError ? 'alert' : 'status');
    toast.innerHTML = html;
    toast.classList.add('is-on');
    clearTimeout(toast._t);
    toast._t = setTimeout(() => toast.classList.remove('is-on'), 6000);
    toast.querySelector('.ng-toast__close')?.addEventListener('click', () => toast.classList.remove('is-on'));
  }

  function updateCount(count) {
    const link = document.getElementById('ng-cart-link');
    if (!link) return;
    let badge = link.querySelector('.ng-count');
    if (!badge) { badge = document.createElement('span'); badge.className = 'ng-count'; badge.setAttribute('aria-hidden', 'true'); link.appendChild(badge); }
    badge.textContent = count;
    link.setAttribute('aria-label', `סל הקניות, ${count} פריטים`);
  }

  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('form[data-ng-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    btn?.setAttribute('aria-busy', 'true');
    if (btn) btn.disabled = true;
    try {
      const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
        method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form),
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'לא הצלחנו להוסיף את המוצר לסל');
      const cart = await (await fetch((window.Shopify?.routes?.root || '/') + 'cart.js')).json();
      updateCount(cart.item_count);
      const gap = (cfg.threshold || 0) - cart.total_price;
      const pct = cfg.threshold ? Math.min(100, Math.round((cart.total_price / cfg.threshold) * 100)) : 100;
      const ship = !cfg.threshold ? '' : gap > 0
        ? `<p class="ng-toast__ship">חסרים לך <b>${money(gap)}</b> למשלוח חינם</p>`
        : '<p class="ng-toast__ship"><b>יש לך משלוח חינם!</b></p>';
      showToast(`
        <div class="ng-toast__head">${cfg.checkIcon || ''}<b>נוסף לסל</b><button type="button" class="ng-toast__close" aria-label="סגירה">×</button></div>
        <p class="ng-toast__item">${(data.product_title || form.dataset.productTitle || '').replace(/</g, '&lt;')}</p>
        ${ship}
        ${cfg.threshold ? `<div class="ng-toast__bar" aria-hidden="true"><span style="width:${pct}%"></span></div>` : ''}
        <div class="ng-toast__actions">
          <a class="ng-btn ng-btn--navy" href="${cfg.cartUrl || '/cart'}">לסל (${money(cart.total_price)})</a>
        </div>`);
      document.dispatchEvent(new CustomEvent('ng:cart-added', { detail: { item: data, cart } }));
    } catch (err) {
      showToast(`<div class="ng-toast__head"><b>${String(err.message).replace(/</g, '&lt;')}</b><button type="button" class="ng-toast__close" aria-label="סגירה">×</button></div>`, true);
    } finally {
      btn?.removeAttribute('aria-busy');
      if (btn) btn.disabled = false;
    }
  });
})();
